export const useDeviceId = () => {
	const deviceId = useLocalStorage('deviceId', generateDeviceId());

	function generateDeviceId() {
		// Generate a random device ID (you can use any method you prefer)
		return `device-${getId()}`;
	}

	return {
		deviceId: readonly(deviceId),
	};
};
